import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';
import { OPD_API_URL } from '../../properties/opd-url-properties';
import { MICROSERVICES } from 'projects/lib/medcare-core-lib/src/lib/constants/web-services';
import { MultiLanguageService } from 'projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service';
import { AppBaseService } from 'projects/lib/medcare-core-lib/src/lib/services/http.service';

@Component({
  selector: 'app-updatestatus',
  templateUrl: './updatestatus.component.html',
  styleUrls: ['./updatestatus.component.scss']
})
export class UpdatestatusComponent implements OnInit,OnDestroy {

  // Reason: any;
  Note: any;
  Option:any;
  // Reasons: any;
  private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);
  Status: any[] = [];
  status: any = "";
  constructor(
    public dialogRef: MatDialogRef<UpdatestatusComponent>,
    public baseHttpService: AppBaseService,
    private langService: MultiLanguageService,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}


  ngOnInit() {   

    this.baseHttpService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
    this.baseHttpService
      .getResource(OPD_API_URL.STATUS_UPDATE)
      .subscribe((res) => {
        res.forEach((element) => {
          this.Status.push(element);
        });
      });
  }



  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  /**
   * On close click
   * @memberof CancelDischargeComponent
   */
  onNoClick(): void {
    this.dialogRef.close();
  }

  /**
   * On save click
   * @memberof CancelDischargeComponent
   */
  onSaveClick(): void {
    var data = {
      status:this.Status,
      note: this.Note,
    };
    this.dialogRef.close(data);
  }

  SaveRemarks(value) {
    if (this.Option) {
      let data = {
        // confirm: value,
        status:this.Option,
        // reason: this.Reason,
        remark: this.Note,
      };
      this.dialogRef.close(data);
    } 
    else
    {
      this.snackBar.open(
        this.langService.get("AppointmentListPage.giveReason"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
    }
  }

}
